<a
  mat-flat-button
  *ngIf="this.selectedOptionsCount"
  class="clear-all link-button"
  (click)="clear()"
  >Clear</a
>
<mat-form-field>
  <mat-label>Date range</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input
      matStartDate
      data-atm="start-date"
      [formControl]="startDateControl"
      placeholder="Start"
      (dateChange)="startDateChanged($event.value)" />
    <input
      matEndDate
      data-atm="end-date"
      [formControl]="endDateControl"
      placeholder="End"
      (dateChange)="endDateChanged($event.value)" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker
    #picker
    [calendarHeaderComponent]="customDatepickerHeader"></mat-date-range-picker>
</mat-form-field>
<div class="chip-list">
  <mat-chip-list>
    <mat-chip
      mat-button
      *ngFor="let preset of datePresets; let i = index"
      [selected]="selectedPresetIndex === i"
      (click)="toggleFilter(preset, i)">
      {{ preset.label }}
    </mat-chip>
  </mat-chip-list>
</div>
